import * as Feather from "react-feather";

export const ICONS = {
  geo: Feather.Briefcase,
  business: Feather.Calendar,
  product: Feather.Grid,
  customer: Feather.Bookmark,
  application: Feather.Target,
  channel: Feather.ShoppingCart,
};

export const SUB = {
  geo: "Analyze revenue by geographic regions and markets",
  business: "Break down by business units and segments",
  product: "View revenue by products and service categories",
  customer: "Analyze customer types and specific accounts",
  application: "View by end-use applications and markets",
  channel: "Breakdown by distribution and sales channels",
};
